import React from 'react';
import './PlatformBadge.css';

/**
 * Platform Badge Component
 * Displays platform name with platform-specific styling
 * 
 * @param {Object} props
 * @param {string} props.platform - Platform ID: youtube|tiktok|reddit|instagram|twitter|youtube_music
 * @param {string} props.size - Size: small|medium (default: small)
 * @param {boolean} props.showIcon - Whether to show icon (default: true)
 */

const PLATFORM_CONFIG = {
  youtube: { icon: '📺', name: 'YouTube', color: '#FF0000', bgColor: '#FEE2E2', darkColor: '#ff6b6b', darkBgColor: 'rgba(255, 107, 107, 0.2)' },
  tiktok: { icon: '🎵', name: 'TikTok', color: '#000000', bgColor: '#F3F4F6', darkColor: '#e2e8f0', darkBgColor: 'rgba(226, 232, 240, 0.15)' },
  reddit: { icon: '🔴', name: 'Reddit', color: '#FF4500', bgColor: '#FFEDD5', darkColor: '#ff8c69', darkBgColor: 'rgba(255, 140, 105, 0.2)' },
  instagram: { icon: '📷', name: 'Instagram', color: '#E1306C', bgColor: '#FCE7F3', darkColor: '#f472b6', darkBgColor: 'rgba(244, 114, 182, 0.2)' },
  twitter: { icon: '𝕏', name: 'Twitter/X', color: '#1DA1F2', bgColor: '#DBEAFE', darkColor: '#60a5fa', darkBgColor: 'rgba(96, 165, 250, 0.2)' },
  youtube_music: { icon: '🎶', name: 'YT Music', color: '#FF0000', bgColor: '#FEE2E2', darkColor: '#ff6b6b', darkBgColor: 'rgba(255, 107, 107, 0.2)' }
};

function PlatformBadge({ platform, size = 'small', showIcon = true }) {
  const config = PLATFORM_CONFIG[platform] || { 
    icon: '🌐', 
    name: platform, 
    color: '#6B7280', 
    bgColor: '#F3F4F6',
    darkColor: '#94a3b8',
    darkBgColor: 'rgba(148, 163, 184, 0.15)'
  };

  // Use CSS custom properties for dark mode support
  const style = {
    '--platform-color': config.color,
    '--platform-bg': config.bgColor,
    '--platform-dark-color': config.darkColor,
    '--platform-dark-bg': config.darkBgColor,
    backgroundColor: config.bgColor,
    color: config.color,
    borderColor: config.color
  };

  return (
    <span className={`platform-badge platform-badge-${size} platform-${platform}`} style={style}>
      {showIcon && <span className="platform-icon">{config.icon}</span>}
      <span className="platform-name">{config.name}</span>
    </span>
  );
}

export { PLATFORM_CONFIG };
export default PlatformBadge;
